import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../rootReducer';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../services/api';
import { fetchUserById } from '../auth/login.thunks';
import { showErrorMessage, showSuccessMessage } from '../notifications';

export interface IUpdateUserPayload {
  firstName: string;
  lastName: string;
  avatar: string;
  phone: string;
  id: string;
  accountId: string;
}

export const updateUserById: AsyncThunk<void, IUpdateUserPayload, ThunkAPI> = createAsyncThunk(
  '',
  async (user: IUpdateUserPayload, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IUpdateUserPayload>({
        endpoint: 'users',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Patch,
        contentType: 'application/json'
      })(user, thunk);
      return response;
    } catch (err) {
      return thunk.rejectWithValue(err);
    } finally {
      setTimeout(() => {
        // Wait until image is ready
        thunk.dispatch(fetchUserById(user.id));
      }, 100);
    }
  }
);

export interface IUpdateUserPasswordPayload{
  oldPassword: string;
  newPassword: string;
}

interface IError {
  message?: string;
}

const isUpdatePasswordError = (error: unknown): error is IError => {
  return typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string';
};

export const updateUserPassword: AsyncThunk<void, IUpdateUserPasswordPayload, ThunkAPI> = createAsyncThunk(
  '',
  async (user: IUpdateUserPasswordPayload, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IUpdateUserPasswordPayload>({
        endpoint: 'users/updatePassword',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(user, thunk);
      thunk.dispatch(showSuccessMessage('Password updated successfully'));
      return response;
    } catch (err) {
      if (isUpdatePasswordError(err)) {
        thunk.dispatch(showErrorMessage(err.message || ''));
      } else if (typeof err === 'string') {
        thunk.dispatch(showErrorMessage(err));
      }
      return thunk.rejectWithValue(err);
    }
  }
);